module.exports = __webpack_public_path__ + "img/random-fail-student.769d4e73.png";